import "./AboutContact.module.css";
import Header from "@/reusable_sections/Header";
import Advocates from "./sections/Advocates";
import Contact from "./sections/Contact";
import Location from "./sections/Location";
import Footer from "@/reusable_sections/Footer";
export default function AboutContactPage() {
  return <div>
      <Header />
      <Advocates />
      <Contact />
      <Location />
      <Footer />
    </div>;
}